import { Payload, usePost } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';

const CalculateSerialNumberParser = (response) => {
    return {
        ...response,
    };
};

export const useCalculateSerialNumber = () => {

    return usePost<Payload<{ ProductId: number; Warehouse: number } & any>, any>
        (APIRoutes.SerialNumber.calculateSerial, null, { responseParser: CalculateSerialNumberParser });
};
